import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from './firebase';

/** Upload one (already compressed) image into `folder`; resolves with its storage path. */
export function uploadImage(
  folder: string,
  file: File,
  onProgress: (fraction: number) => void,
): Promise<string> {
  const ext = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
  const path = `${folder}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
  const task = uploadBytesResumable(ref(storage, path), file, { contentType: file.type });
  return new Promise((resolve, reject) => {
    task.on(
      'state_changed',
      (snap) => onProgress(snap.totalBytes ? snap.bytesTransferred / snap.totalBytes : 0),
      reject,
      () => resolve(path),
    );
  });
}

export function getImageUrl(path: string): Promise<string> {
  return getDownloadURL(ref(storage, path));
}
